import AnnualReportItem from './AnnualReportItem';
export default class AnnualReport {
    static fromPartial(partial) {
        var _a, _b;
        const annualReport = new AnnualReport();
        const translation = (_a = partial.translations) === null || _a === void 0 ? void 0 : _a.pop();
        annualReport.title = (_b = translation === null || translation === void 0 ? void 0 : translation.title) !== null && _b !== void 0 ? _b : '';
        if (partial.annual_report_items) {
            annualReport.items = new Array();
            for (const item of partial.annual_report_items) {
                if (item) {
                    const annualReportItem = AnnualReportItem.fromPartial(item);
                    annualReport.items.push(annualReportItem);
                }
            }
        }
        return annualReport;
    }
}
